// PositionCard — Position row (Angel One light theme)
import React from 'react';
import PnLBadge from './PnLBadge';

export default function PositionCard({ position, onTrade }) {
  const netQty = parseInt(position.netqty) || 0;
  const isLong = netQty > 0;

  return (
    <div className="grid grid-cols-12 gap-2 px-4 py-2.5 border-b border-gray-100 hover:bg-gray-50 items-center text-xs group">
      <div className="col-span-2">
        <p className="font-medium text-gray-900">{position.tradingsymbol}</p>
        <p className="text-[10px] text-gray-400">{position.exchange}</p>
      </div>
      <div className="col-span-1 text-gray-500 text-[10px]">{position.producttype}</div>
      <div className="col-span-1 text-right">
        <span className={`font-mono font-semibold ${isLong ? 'text-green-600' : netQty < 0 ? 'text-red-500' : 'text-gray-500'}`}>
          {netQty}
        </span>
      </div>
      <div className="col-span-2 text-right font-mono text-gray-900">
        ₹{parseFloat(position.netprice || 0).toFixed(2)}
      </div>
      <div className="col-span-2 text-right font-mono text-gray-900">
        ₹{position.ltp?.toFixed(2) || '—'}
      </div>
      <div className="col-span-2 text-right">
        <PnLBadge value={position.totalPnL} size="sm" />
        <p className="text-[9px] text-gray-400 font-mono">{position.pnlPercent?.toFixed(2)}%</p>
      </div>
      <div className="col-span-2 flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
        {netQty !== 0 && (
          <button
            onClick={() => onTrade({
              instrument: {
                token: position.symboltoken,
                symbol: position.tradingsymbol,
                exchange: position.exchange,
              },
              side: isLong ? 'SELL' : 'BUY',
            })}
            className={`px-2.5 py-1 rounded text-[10px] font-bold ${
              isLong ? 'bg-red-50 text-red-600 hover:bg-red-100' : 'bg-green-50 text-green-600 hover:bg-green-100'
            }`}
          >
            {isLong ? 'EXIT' : 'COVER'}
          </button>
        )}
      </div>
    </div>
  );
}
